import PropTypes from "prop-types";
import { message } from "antd";
import AppleButton from "../../assets/logo/apple-store-button.png";
import GoogleButton from "../../assets/logo/google-play-button.png";

const openAppStore = (url) => {
  if (!url) {
    console.error("No URL provided");
    return;
  }
  window.open(url, "_blank");
};

const SpStoreButtons = ({ buttonHeight = "60px", buttonWidth = "180px" }) => {
  const handleStoreClick = (store) => {
    message.info(`${store} app coming soon!`);
  };

  const buttonStyle = {
    display: "inline-block",
    transition: "transform 0.2s ease",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    cursor: "pointer",
  };

  const imageStyle = {
    height: buttonHeight,
    width: "auto",
    maxWidth: buttonWidth,
    display: "block",
    borderRadius: "8px",
    transition: "opacity 0.2s ease",
  };

  return (
    <div
      style={{
        display: "flex",
        gap: "16px",
        marginTop: "32px",
        marginBottom: "24px",
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      {/* Google Play Button */}
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          /* openAppStore(
            "https://play.google.com/store/apps/details?id=com.bridgepayments-web.bridgepayments"
          ); */
        }}
        style={buttonStyle}
        onMouseEnter={(e) => {
          e.target.style.transform = "translateY(-2px)";
          e.target.style.boxShadow = "0 4px 16px rgba(0, 0, 0, 0.15)";
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = "translateY(0)";
          e.target.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.1)";
        }}
      >
        <img
          src={GoogleButton}
          alt="Download on Google Play"
          style={imageStyle}
          onMouseEnter={(e) => (e.target.style.opacity = "0.9")}
          onMouseLeave={(e) => (e.target.style.opacity = "1")}
        />
      </a>

      {/* Apple Store Button */}
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          handleStoreClick("App Store");
        }}
        style={buttonStyle}
        onMouseEnter={(e) => {
          e.target.style.transform = "translateY(-2px)";
          e.target.style.boxShadow = "0 4px 16px rgba(0, 0, 0, 0.15)";
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = "translateY(0)";
          e.target.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.1)";
        }}
      >
        <img
          src={AppleButton}
          alt="Download on the App Store"
          style={imageStyle}
          onMouseEnter={(e) => (e.target.style.opacity = "0.9")}
          onMouseLeave={(e) => (e.target.style.opacity = "1")}
        />
      </a>
    </div>
  );
};

SpStoreButtons.propTypes = {
  buttonHeight: PropTypes.string,
  buttonWidth: PropTypes.string,
};

export default SpStoreButtons;
